// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Skeleton, Table } from '@/ui';
import { Pagination } from '@/components';
import { StyledWrapper } from './RegionsListStyles';

// Models
import { IRegion } from '@/models/regions.model';

// Helpers
import { getRegionsTableColumns } from './columns';

type TRegionsList = {
  regionsList: IRegion[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  canManage: boolean;
  onStatusChange: (id: string) => void;
  onPageChange: (page: number) => void;
};

const RegionsList = ({
  isLoading,
  regionsList,
  total,
  currentPage,
  canManage,
  onPageChange,
  onStatusChange,
}: TRegionsList) => {
  const { t } = useTranslation(['regions']);

  if (isLoading) return <Skeleton />;

  return (
    <StyledWrapper>
      <Table columns={getRegionsTableColumns({ t, onStatusChange, canManage })} dataSource={regionsList} />
      <Pagination current={currentPage} total={total} onChange={onPageChange} />
    </StyledWrapper>
  );
};

export default RegionsList;
